import React from 'react';

// eslint-disable-next-line react/prop-types
export default function NavIcon({ Icon }) {return <Icon height="2em" width="2em" />;
}
